// extracted by extract-css-chunks-webpack-plugin
module.exports = {"toolTip":"_2iguAW","colHousing":"_1Htk3K","colTransportation":"_1mt7T1","colFood":"_1f9xE1","colEntertainment":"_2eW_cl","colHealthcare":"_3clJkG","colSchool":"_2XPdbp"};